import React, { useState, useEffect } from 'react';
import { fetchDevicePictures } from '../../services/apiService.js';

const SensorImageThumbnail = React.memo(({ deviceId, onImageClick }) => {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadImage = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const picturesData = await fetchDevicePictures(deviceId);
        const pictures = picturesData.pictures || [];
        
        if (pictures.length > 0) {
          setImage(pictures[0]); // Latest image
        }
      } catch (err) {
        console.error(`Error loading image for device ${deviceId}:`, err);
        setError('Failed to load image');
      } finally {
        setLoading(false);
      }
    };

    loadImage();
  }, [deviceId]);

  if (loading) {
    return (
      <div className="image-thumbnail loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (error || !image) {
    return (
      <div className="image-thumbnail no-image">
        <span>No Image</span>
      </div>
    );
  }

  return (
    <div 
      className="image-thumbnail"
      onClick={() => onImageClick(image)}
      title="Click to view full image"
    >
      <img 
        src={image.url} 
        alt={`Latest image for device ${deviceId}`}
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'block';
        }}
      />
      <div className="image-fallback" style={{ display: 'none' }}>
        <span>Image Error</span>
      </div>
    </div>
  );
});

export default SensorImageThumbnail;